/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as GameImport } from './routes/game';
import { Route as Import } from './routes/*';
import { Route as IndexImport } from './routes/index';
import { Route as GameIndexImport } from './routes/game/index';
import { Route as GameMintImport } from './routes/game/mint';
import { Route as GameCompletedSquashImport } from './routes/game/completedSquash';

// Create/Update Routes

const GameRoute = GameImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRoute,
} as any);

const Route = Import.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const GameIndexRoute = GameIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GameRoute,
} as any);

const GameMintRoute = GameMintImport.update({
  id: '/mint',
  path: '/mint',
  getParentRoute: () => GameRoute,
} as any);

const GameCompletedSquashRoute = GameCompletedSquashImport.update({
  id: '/completedSquash',
  path: '/completedSquash',
  getParentRoute: () => GameRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/*': {
      id: '/*';
      path: '/*';
      fullPath: '/*';
      preLoaderRoute: typeof Import;
      parentRoute: typeof rootRoute;
    };
    '/game': {
      id: '/game';
      path: '/game';
      fullPath: '/game';
      preLoaderRoute: typeof GameImport;
      parentRoute: typeof rootRoute;
    };
    '/game/completedSquash': {
      id: '/game/completedSquash';
      path: '/completedSquash';
      fullPath: '/game/completedSquash';
      preLoaderRoute: typeof GameCompletedSquashImport;
      parentRoute: typeof GameImport;
    };
    '/game/mint': {
      id: '/game/mint';
      path: '/mint';
      fullPath: '/game/mint';
      preLoaderRoute: typeof GameMintImport;
      parentRoute: typeof GameImport;
    };
    '/game/': {
      id: '/game/';
      path: '/';
      fullPath: '/game/';
      preLoaderRoute: typeof GameIndexImport;
      parentRoute: typeof GameImport;
    };
  }
}

// Create and export the route tree

interface GameRouteChildren {
  GameCompletedSquashRoute: typeof GameCompletedSquashRoute;
  GameMintRoute: typeof GameMintRoute;
  GameIndexRoute: typeof GameIndexRoute;
}

const GameRouteChildren: GameRouteChildren = {
  GameCompletedSquashRoute: GameCompletedSquashRoute,
  GameMintRoute: GameMintRoute,
  GameIndexRoute: GameIndexRoute,
};

const GameRouteWithChildren = GameRoute._addFileChildren(GameRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/game': typeof GameRouteWithChildren;
  '/game/completedSquash': typeof GameCompletedSquashRoute;
  '/game/mint': typeof GameMintRoute;
  '/game/': typeof GameIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/game/completedSquash': typeof GameCompletedSquashRoute;
  '/game/mint': typeof GameMintRoute;
  '/game': typeof GameIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/*': typeof Route;
  '/game': typeof GameRouteWithChildren;
  '/game/completedSquash': typeof GameCompletedSquashRoute;
  '/game/mint': typeof GameMintRoute;
  '/game/': typeof GameIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/*'
    | '/game'
    | '/game/completedSquash'
    | '/game/mint'
    | '/game/';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/*' | '/game/completedSquash' | '/game/mint' | '/game';
  id:
    | '__root__'
    | '/'
    | '/*'
    | '/game'
    | '/game/completedSquash'
    | '/game/mint'
    | '/game/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  Route: typeof Route;
  GameRoute: typeof GameRouteWithChildren;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Route: Route,
  GameRoute: GameRouteWithChildren,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/*",
        "/game"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/*": {
      "filePath": "*.tsx"
    },
    "/game": {
      "filePath": "game.tsx",
      "children": [
        "/game/completedSquash",
        "/game/mint",
        "/game/"
      ]
    },
    "/game/completedSquash": {
      "filePath": "game/completedSquash.tsx",
      "parent": "/game"
    },
    "/game/mint": {
      "filePath": "game/mint.tsx",
      "parent": "/game"
    },
    "/game/": {
      "filePath": "game/index.tsx",
      "parent": "/game"
    }
  }
}
ROUTE_MANIFEST_END */
